import { usePortalTranslations } from '../hooks/usePortalTranslations';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function PortalMessage({
  messageKey,
  subKey,
  locale,
  fallback
}) {
  var _portalText;
  const {
    portalText
  } = usePortalTranslations(locale);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (_portalText = portalText(messageKey, subKey)) !== null && _portalText !== void 0 ? _portalText : fallback
  });
}